import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import { IAttachDocumentInvoices } from 'src/types/AttachDocumentInvoices';
import { IPostBody } from 'src/types/PostBody';
import axiosInstance from 'src/utils/axios';

interface AttachDocumentRequest {
  companyId?: string;
  body?: IPostBody;
  uploadsOlderThan90Days?: boolean;
}

interface AttachDocumentResponse {
  totalRecords: number;
  items: IAttachDocumentInvoices[];
}

const useAttachDocumentInvoiceApi = () => {
  const call = useCallback(
    ({ companyId, body, uploadsOlderThan90Days = true }: AttachDocumentRequest = {}) =>
      new Promise<AttachDocumentResponse>((resolve, reject) => {
        axiosInstance
          .post<AttachDocumentResponse>(
            api.getScanInvoiceDataUrlFn(parseInt(companyId || ''), uploadsOlderThan90Days),
            body
          )
          .then((data) => {
            resolve({
              totalRecords: data.data.totalRecords,
              items: data.data.items.map((item) => ({
                ...item,
                preview: false,
                NonEditableFilename: item.originalFile,
              })),
            });
          })
          .catch((error) => {
            reject(error);
          });
      }),
    []
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    attachDocument: execute,
    isAttachDocumentLoading: isLoading,
  };
};

export default useAttachDocumentInvoiceApi;
